import {useRole} from './useRole';
import {URLS} from '../Routing';

export type TSettingsGroup = 'Personal' | 'Organization';

export interface ISettingOption {
  label: string;
  to: string;
  group: TSettingsGroup;
  disabled: boolean;
}

// Helper to generate the settings-nav list based on what the caller can do
export const useDefineSettings = (): ISettingOption[] => {
  const {isAdmin} = useRole();
  // Hidden until Groups is redesigned
  const groupsEnabled = false;
  const disclaimersEnabled = true;

  const items: (ISettingOption & {show?: boolean})[] = [
    {label: 'My Profile', to: URLS.SETTINGS_PROFILE.build(), group: 'Personal', disabled: false},
    {label: 'Security', to: URLS.SETTINGS_SECURITY.build(), group: 'Personal', disabled: false},
    {label: 'Org Profile', to: URLS.SETTINGS_ORGANIZATION.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Branding', to: URLS.SETTINGS_BRANDING.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Data Catalogs', to: URLS.SETTINGS_DATA_CATALOGS.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Groups', to: URLS.SETTINGS_GROUPS.build(), group: 'Organization', disabled: !isAdmin, show: groupsEnabled},
    {label: 'Members', to: URLS.SETTINGS_MEMBERS.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'API Keys & MCP', to: URLS.SETTINGS_API_KEYS.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Webhooks', to: URLS.SETTINGS_WEBHOOKS.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Document Processing', to: URLS.SETTINGS_PIPELINE.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Hierarchy', to: URLS.SETTINGS_HIERARCHY.build(), group: 'Organization', disabled: !isAdmin},
    {label: 'Usage', to: URLS.SETTINGS_USAGE.build(), group: 'Organization', disabled: !isAdmin},
  ];

  return items.filter((item) => item.show !== false).map(({show, ...item}) => item);
};
